import { showExperimentalFeatures } from 'pages/raas/DeploymentDetails/helpers/visibility';
import { RollupType } from 'pages/raas/helpers/labels';
import { NavigationItem } from 'shared/types/navigation';
import { Rollup, RollupStatus } from 'shared/types/protoc-gen/raas-rollup';

import { isOpstack } from '../helpers/rollup';

export const getSideNavigationItems = (
  path: string | undefined,
  rollup: Rollup,
): NavigationItem[] =>
  [
    {
      id: 'rollup-management',
      label: 'Rollup Management',
      items: [
        {
          label: 'Rollup Info',
          to: `${path}/info`,
        },
        {
          label: 'Start a Fullnode',
          to: `${path}/start-fullnode`,
          hidden: rollup.status === RollupStatus.ROLLUPSTATUS_PAUSE || !showExperimentalFeatures,
        },
        {
          label: 'Customization',
          to: `${path}/customization`,
          hidden: rollup.status === RollupStatus.ROLLUPSTATUS_PAUSE || !showExperimentalFeatures,
        },
      ],
    },
    {
      id: 'operational-metrics',
      label: 'Operational Metrics',
      items: [
        {
          label: 'Rollup Statistics',
          to: `${path}/stats`,
        },
        {
          label: 'Bridge Metrics',
          to: `${path}/bridge`,
        },
        {
          label: 'Fee Tracker',
          to: `${path}/fee-tracker`,
        },
      ],
    },
    {
      id: 'technical-metrics',
      label: 'Technical Metrics',
      items: [
        {
          label: 'Rollup Statistics',
          to: `${path}/rollup-statistics`,
        },
        {
          label: 'Blockchain Statistics',
          to: `${path}/blockchain-stats`,
        },
        {
          label: 'Proposer',
          to: `${path}/proposer`,
        },
        {
          label: 'Batcher',
          to: `${path}/batcher`,
        },
      ],
    },
    {
      id: 'plugin-service',
      label: 'Plugin Service',
      items: [
        {
          label: 'Balance Alert',
          to: `${path}/balance`,
        },
        {
          label: 'Fee Withdrawal',
          to: `${path}/withdrawal-fee`,
          //  TODO: Remove hiding on VERSE after BE Support is done
          hidden: !isOpstack(rollup.type as RollupType) || rollup.type === RollupType.VERSE,
          disabled: !!rollup.accounts?.challengeResolver,
          disabledTooltip:
            'Fee withdrawal is not currently supported for OP Stack with fraud proof.',
        },
        {
          label: 'RPC Usage Monitoring',
          to: `${path}/rpc`,
          hidden: !(isOpstack(rollup.type as RollupType) || rollup.type === RollupType.ORBIT),
        },
      ],
    },
    {
      id: 'troubleshooting',
      label: 'Troubleshooting',
      items: [
        {
          label: 'FAQ',
          to: `${path}/faq`,
        },
        {
          label: 'Contact us',
          to: `${path}/contact-us`,
        },
      ],
    },
  ].filter(({ id }) => {
    if (rollup.status === RollupStatus.ROLLUPSTATUS_PAUSE) {
      return id === 'rollup-management';
    }

    // Show everything for OP Stack
    if (isOpstack(rollup.type as RollupType)) return true;

    // Only show basic panels for other rollup types
    return ['rollup-management', 'troubleshooting', 'plugin-service'].includes(id);
  });
